import { render, staticRenderFns } from "./tai-xiu-pane.vue?vue&type=template&id=148c63a5&scoped=true"
import script from "./tai-xiu-pane.vue?vue&type=script&lang=js"
export * from "./tai-xiu-pane.vue?vue&type=script&lang=js"
import style0 from "./tai-xiu-pane.vue?vue&type=style&index=0&id=148c63a5&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "148c63a5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gameclient/gameclient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('148c63a5')) {
      api.createRecord('148c63a5', component.options)
    } else {
      api.reload('148c63a5', component.options)
    }
    module.hot.accept("./tai-xiu-pane.vue?vue&type=template&id=148c63a5&scoped=true", function () {
      api.rerender('148c63a5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/desktop/tai-xiu-pane.vue"
export default component.exports